import { POSTCODE_ID } from '../../../const';

export default [
  {
    id: '4651266c-f0eb-479e-a93e-49d7829adefe',
    questionOrder: 8,
    readableId: POSTCODE_ID,
    type: 'postcode',
    title: 'Where are you searching?',
    helpText: 'Type the postcode where you want to find football below.',
    placeholder: 'Enter your postcode',
    ageRanges: [
      {
        min: 0,
        max: 0,
        nextQuestionId: null,
      },
    ],
  },
];
